import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AppContainer from './AppContainer';

const RouterSwitcher = () =>
  <Switch>
    <Route exact path="/jobs/(search|browse)/" component={AppContainer} />
    <Route path="/jobs/(search|browse)/:seokey" component={AppContainer} />

    <Route exact path="/en-(au|gb|ie|ca|nz|us)/jobs/(search|browse)/" component={AppContainer} />
    <Route path="/en-(au|gb|ie|ca|nz|us)/jobs/(search|browse)/:seokey" component={AppContainer} />
  </Switch>;

export default RouterSwitcher;
